import IconClose from '@apollo/icons/default/IconClose.svg';
import type { SystemStyleObject } from '@chakra-ui/react';
import type { ComponentPropsWithoutRef } from 'react';
import React from 'react';

import { withChakraAs } from '../../utils/withChakraAs';
import { IconButton } from '../IconButton/IconButton';

type IconButtonProps = ComponentPropsWithoutRef<typeof IconButton>;

export interface CloseButtonProps
  extends Omit<IconButtonProps, 'icon' | 'aria-label'> {
  'aria-label'?: IconButtonProps['aria-label'];
  /** @internal Do not use outside of Orbit */
  __orbitStyleConfig?: SystemStyleObject;
}

export const CloseButton = withChakraAs<CloseButtonProps, 'button'>(
  ({ __orbitStyleConfig, ...props }) => {
    return (
      <IconButton
        variant="hidden"
        {...props}
        aria-label={props['aria-label'] || 'Close'}
        icon={<IconClose />}
        sx={__orbitStyleConfig}
      />
    );
  },
);
